exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".number_bar_widget{color:#fff;text-align:center;width:80%!important;height:80%!important;box-sizing:border-box;position:absolute;top:50%;left:50%;transform:translate(-50%, -50%);padding-top:65px}.number_bar_widget h2{letter-spacing:-3px}.number_bar_widget h5{margin:0 0 5%;letter-spacing:-3px}.number_bar_widget .progress_bar_container{background:hsla(0,0%,100%,.2);fill:hsla(0,0%,100%,.2);height:10px}.number_bar_widget .progress_bar{fill:hsla(0,0%,100%,.8);height:10px}.number_bar_widget svg text{dominant-baseline:middle;text-anchor:middle;font-weight:500;fill:#fff}.number_bar_widget svg text .budget{font-size:7px;font-weight:500;fill:hsla(0,0%,100%,.7)}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded!./client/components/Widgets/NumberWidgetBar.scss
 ** module id = 775
 ** module chunks = 0
 **/